// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1jkfz2k0 {
  text-align: right;
  padding: 10px;
  min-width: 150px;
  width: 150px;
}
._1jkfz2k0:first-of-type {
  text-align: left;
  width: 180px;
  min-width: 180px;
  padding-left: 15px;
}
._1jkfz2k1:nth-of-type(odd) {
  background-color: rgba(0,0,0,.05);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iCAAiC;AACnC","sourcesContent":["._1jkfz2k0 {\n  text-align: right;\n  padding: 10px;\n  min-width: 150px;\n  width: 150px;\n}\n._1jkfz2k0:first-of-type {\n  text-align: left;\n  width: 180px;\n  min-width: 180px;\n  padding-left: 15px;\n}\n._1jkfz2k1:nth-of-type(odd) {\n  background-color: rgba(0,0,0,.05);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
